module.exports = __webpack_public_path__ + "tf.svg?f3cb00d839fe254e9352e724cc3f1e59";